/**
 * Footer email signup: no-refresh submit + thank-you message, and an optional
 * copy of each signup to a Google Sheet.
 *
 * Why an iframe and not fetch: Shopify's /contact endpoint returns HTTP 400 to
 * any XHR/fetch POST -- verified against this store with minimal fields, with
 * contact[id], with contact[tags], and in both multipart and urlencoded form.
 * It only accepts real document submissions. So we let the browser do its normal
 * native submit, but point form.target at a hidden iframe: Shopify sees the
 * request it expects, and the top-level page never navigates.
 *
 * Config comes from window.WhippdSheets, set in layout/theme.liquid.
 */
(function () {
  'use strict';

  var CONFIG = window.WhippdSheets || {};
  var ENDPOINT = (CONFIG.endpoint || '').trim();
  var SECRET = CONFIG.secret || '';
  var THANKS = CONFIG.thanks || 'Thanks for subscribing!';
  var ICON = CONFIG.icon || '';

  var FRAME_NAME = 'whippd-signup-frame';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var frame = null;
  var lastSent = { email: '', at: 0 };

  function getFrame() {
    if (frame && document.body.contains(frame)) return frame;
    frame = document.createElement('iframe');
    frame.name = FRAME_NAME;
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.setAttribute('title', 'Email signup');
    frame.style.cssText =
      'position:absolute;width:0;height:0;border:0;visibility:hidden;left:-9999px;';
    document.body.appendChild(frame);
    return frame;
  }

  /** Fire-and-forget copy to the Google Sheet. Never blocks the real signup. */
  function sendToSheet(email, form) {
    if (!ENDPOINT) return;

    var now = Date.now();
    if (email === lastSent.email && now - lastSent.at < 10000) return;
    lastSent = { email: email, at: now };

    var payload = JSON.stringify({
      email: email,
      secret: SECRET,
      source: form && form.closest('footer') ? 'footer' : 'other',
      page: location.pathname
    });

    // text/plain keeps this a CORS "simple request" -- no preflight, which Apps
    // Script web apps do not answer.
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: payload
      });
    } catch (e) {
      /* ignore */
    }
  }

  function showThanks(form) {
    if (form.dataset.thanked === 'true') return;
    form.dataset.thanked = 'true';

    var group = form.querySelector('.email-signup__input-group');
    var existing = form.querySelector('.email-signup__message--js');
    if (existing) existing.remove();

    var msg = document.createElement('div');
    msg.className = 'email-signup__message email-signup__message--js';
    msg.setAttribute('tabindex', '-1');
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');

    if (ICON) {
      var wrap = document.createElement('span');
      wrap.className = 'svg-wrapper icon-success';
      wrap.innerHTML = ICON;
      msg.appendChild(wrap);
    }

    var p = document.createElement('p');
    p.className = 'email-signup__message-text';
    p.textContent = THANKS;
    msg.appendChild(p);

    form.appendChild(msg);

    // The field has done its job -- hide it so the thank-you stands alone.
    if (group) group.style.display = 'none';

    try {
      msg.focus();
    } catch (e) {
      /* ignore */
    }
  }

  function setBusy(form, busy) {
    var button = form.querySelector('button');
    if (!button) return;
    button.disabled = busy;
    button.style.opacity = busy ? '0.6' : '';
  }

  // Capture phase: runs before any handler that might cancel the submit.
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || !form.classList || !form.classList.contains('email-signup__form')) return;

      var input = form.querySelector('input[name="contact[email]"]');
      if (!input) return;

      var email = String(input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(email)) return; // let native validation handle it

      if (form.dataset.submitting === 'true') {
        evt.preventDefault();
        return;
      }
      form.dataset.submitting = 'true';

      // Deliberately NOT preventDefault: the native submit is what Shopify accepts.
      // Redirecting it into the hidden frame is what stops the page reloading.
      evt.stopPropagation();

      var f = getFrame();
      form.target = FRAME_NAME;

      sendToSheet(email, form);
      setBusy(form, true);

      var settled = false;
      function settle() {
        if (settled) return;
        settled = true;
        setBusy(form, false);
        showThanks(form);
      }

      f.addEventListener('load', settle, { once: true });
      // Fallback: the data has left the browser either way, so don't strand the
      // visitor staring at a disabled button if the frame never reports back.
      setTimeout(settle, 6000);
    },
    true
  );
})();
